<template>
  <div>
    <collapse :active-index="0">
      <collapse-item>
        <h3 slot="title" class="mb-0">Información del Asesor Técnico</h3>

        <div>
          <div class="row">
            <div class="col-sm-6 col-xs-12 text-center text-sm-left">
              <p class="h5 mb-0">Nombre</p>
              <p>{{ seller.name }}</p>
            </div>
            <div class="col-sm-6 col-xs-12 text-center text-sm-left">
              <p class="h5 mb-0">Email</p>
              <p>{{ seller.email }}</p>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-6 col-xs-12 text-center text-sm-left">
              <p class="h5 mb-0">Ubicación</p>
              <p class="mb-0">{{ seller.city.name }}, {{ seller.city.province.name }}</p>
              <p>
                <small><span class="font-italic">Dirección: </span>{{ seller.address }}</small>
              </p>
            </div>
            <div class="col-sm-6 col-xs-12 text-center text-sm-left">
              <p class="h5 mb-0">Teléfono</p>
              <p>{{ seller.phone }}</p>
            </div>
            <div class="col-sm-6 col-xs-12 text-center text-sm-left">
              <p class="h5 mb-0">Última visita</p>
              <p v-if="seller.lastVisitDate">{{ seller.lastVisitDate | date }}</p>
              <p v-else>-</p>
            </div>
            <div class="col-sm-6 col-xs-12 text-center text-sm-left">
              <p class="h5 mb-0">Comisión</p>
              <p v-if="seller.commission">{{ seller.commission }} %</p>
              <p v-else>-</p>
            </div>

            <div class="col-sm-12 text-center text-sm-left">
              <badge class="mb-0 mr-1" type="danger">
                <span class="mr-1">{{ seller.visitsCount }}</span>
                <span v-if="seller.visitsCount === 1">Visita</span>
                <span v-else>Visitas</span>
              </badge>
              <badge class="mb-0 mr-1" type="success">
                <span class="mr-1">{{ seller.distributorsVisitsCount }}</span>
                <span>Visitas Distribuidores</span>
              </badge>
            </div>
          </div>
        </div>
      </collapse-item>
    </collapse>
  </div>
</template>

<script>
import Collapse from '@/components/Collapse/Collapse';
import CollapseItem from '@/components/Collapse/CollapseItem';

export default {
  name: 'SellerData',
  components: {
    Collapse,
    CollapseItem,
  },

  props: {
    seller: {
      type: Object,
      default: null,
    },
  },
};
</script>
